import { useState } from 'react';
import useFetch from '../hooks/useFetch'
import { objectToQueryString } from '../utils';
import { apiWrapper } from './dataHookUtils'

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  const [hotels, setHotels] = useState([])

  const fetch = useFetch()

  const postHeaders = { "Content-Type": "application/json" }

  const fetchHotels = async (filters = {}) => {
    try {
      setIsLoading(true);
      const response = await fetch(`events/event/hotels?${objectToQueryString(filters)}`, { method: 'GET' })
      const jsonData = await response.json()
      if (jsonData.error) {
        setHotels([])
      } else {
        setHotels(jsonData)
      }
     setIsLoading(false)
    } catch (e) {
      console.log(e)
      setHotels([])
      setIsLoading(false)
    }
  }

  const addNewHotel = async (hotelData) => {
    return apiWrapper({
      fetch,
      url: `events/event/hotel/new`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: hotelData })
      }
    });
  }

  const updateHotel = async (hotelData) => {
    return apiWrapper({
      fetch,
      url: `events/event/hotel/update`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: hotelData })
      }
    });
  }

  const deleteHotel = async (hotelData) => {
    return apiWrapper({
      fetch,
      url: `events/event/hotel/delete`,
      options: {
        method: 'POST', 
        headers: postHeaders,
        body: JSON.stringify({ data: hotelData })
      }
    });
  }

  return {
    isLoading,
    hotels,
    fetchHotels,
    addNewHotel,
    updateHotel,
    deleteHotel
  }
}